import * as faceapi from "face-api.js"

let loadPromise = null

/** Charge les modèles face-api.js une seule fois (WebGL, repli CPU). */
export function loadFaceModels() {
  if (!loadPromise) {
    loadPromise = (async () => {
      try {
        await faceapi.tf.setBackend("webgl")
      } catch {
        await faceapi.tf.setBackend("cpu")
      }
      await faceapi.tf.ready()

      await faceapi.nets.tinyFaceDetector.loadFromUri("/models")
      await faceapi.nets.faceLandmark68Net.loadFromUri("/models")
      await faceapi.nets.faceRecognitionNet.loadFromUri("/models")
    })()
  }
  return loadPromise
}

export const FACE_DETECT_OPTIONS = new faceapi.TinyFaceDetectorOptions({
  inputSize: 416,
  scoreThreshold: 0.25,
})

/** Retourne la vidéo si le flux caméra est prêt pour la détection. */
export function getReadyVideo(webcamRef) {
  const video = webcamRef.current?.video
  if (
    !video ||
    video.readyState !== 4 ||
    video.videoWidth === 0 ||
    video.videoHeight === 0
  ) {
    return null
  }
  return video
}
